import { useState, useEffect } from 'react';

export const useBookingSession = (expiryTime, onExpired = null) => {
  const [isExpired, setIsExpired] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [hasTriggeredExpiry, setHasTriggeredExpiry] = useState(false);

  useEffect(() => {
    // If no expiry time provided, consider session as valid
    if (!expiryTime || expiryTime <= 0) {
      setIsExpired(false);
      setTimeLeft(0);
      return;
    }

    const updateSession = () => {
      const now = Date.now();
      const remaining = expiryTime - now;

      console.log('🕒 Session check:', {
        now: new Date(now).toLocaleString(),
        expiryTime: new Date(expiryTime).toLocaleString(),
        remaining: remaining,
        isExpired: remaining <= 0
      });

      if (remaining <= 0) {
        setTimeLeft(0);
        setIsExpired(true);
        
        // Trigger expiry callback only once
        if (!hasTriggeredExpiry && onExpired) {
          setHasTriggeredExpiry(true);
          onExpired();
        }
        
        console.log('❌ Booking session has expired');
        return;
      }

      setTimeLeft(remaining);
      setIsExpired(false);
    };

    // Update immediately
    updateSession();

    // Update every second
    const interval = setInterval(updateSession, 1000);

    return () => clearInterval(interval);
  }, [expiryTime, onExpired, hasTriggeredExpiry]);

  return {
    isExpired,
    timeLeft,
    hasValidSession: !isExpired && timeLeft > 0,
    // Helper function to get formatted time remaining
    getTimeRemaining: () => {
      if (timeLeft <= 0) return '00:00';
      const totalSeconds = Math.floor(timeLeft / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  };
};